import React, { useEffect } from 'react'
import {
  Box,
  DialogActions,
  FormControl,
  FormHelperText,
  FormLabel,
  MenuItem,
  RadioGroup,
  TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { TextMaskDollarBills } from '../../common/InputMasks'
import ButtonSubmit from '../../common/ButtonSubmit'
import {
  publishViewed,
  publishChangedInput,
  publishClickedGiftAmount,
} from '../../../util/events/teamsGiftsEventPublishers'
import { VIEWS, ACTION_TARGETS } from '../../../util/events/teamsEvents'
import RadioChipOption from './RadioChipOption'
import { formatCentsToPrettyDollars, GIFT_AMOUNT_OTHER, gitAmountOptions } from './giftCardUtils'
import DialogContent from './DialogContent'

const useStyles = makeStyles(theme => ({
  radioGroup: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  radioHelperText: {
    marginLeft: theme.spacing(2),
  },
}))

const StepGiftDetails = ({ values, errors, touched, handleChange, setFieldValue, handleBlur }) => {
  const classes = useStyles()

  const handleBlurInput = (e, actionTarget) => {
    const error = touched[e.target.name] && errors[e.target.name]
    publishChangedInput(actionTarget, e.target.value, error)
    handleBlur(e)
  }

  const handleChangeRadio = e => {
    const error = touched[e.target.name] && errors[e.target.name]
    publishClickedGiftAmount(e.target.value, error)
    handleChange(e)
  }

  useEffect(() => {
    publishViewed(VIEWS.STEP_GIFT_DETAILS)
  }, [])

  return (
    <>
      <DialogContent>
        <Box marginBottom={4}>
          <TextField
            select
            autoFocus
            name="reason"
            fullWidth
            size="small"
            variant="outlined"
            label="What's the occasion?"
            value={values.reason}
            onChange={handleChange}
            onBlur={e => handleBlurInput(e, ACTION_TARGETS.GIFT_REASON)}
            error={touched.reason && Boolean(errors.reason)}
            helperText={touched.reason && errors.reason}
          >
            <MenuItem value="Birthday">Birthday</MenuItem>
            <MenuItem value="Work Anniversary">Work Anniversary</MenuItem>
            <MenuItem value="Employee of the Month">Employee of the Month</MenuItem>
            <MenuItem value="Performance Reward">Performance Reward</MenuItem>
            <MenuItem value="Team Reward">Team Reward</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>
        </Box>
        <FormControl
          error={touched.amount && Boolean(errors.amount)}
          name="amount"
          component="fieldset"
        >
          <FormLabel component="legend">How much do you want to give?</FormLabel>
          <RadioGroup
            arial-label="gift amount"
            name="amount"
            classes={{ root: classes.radioGroup }}
            value={values.amount}
            onChange={handleChangeRadio}
            row
          >
            {gitAmountOptions.map(value => (
              <RadioChipOption
                key={value}
                value={value}
                content={formatCentsToPrettyDollars(value)}
                checked={values.amount === value}
              />
            ))}
            <RadioChipOption
              value={GIFT_AMOUNT_OTHER}
              content="OTHER"
              checked={values.amount === GIFT_AMOUNT_OTHER}
            />
          </RadioGroup>
          {touched.amount && (
            <FormHelperText className={classes.radioHelperText}>{errors.amount}</FormHelperText>
          )}
        </FormControl>
        {values.amount === GIFT_AMOUNT_OTHER && (
          <Box marginTop={2} marginBottom={4}>
            <TextField
              InputProps={{
                inputComponent: TextMaskDollarBills,
              }}
              name="otherAmount"
              fullWidth
              size="small"
              variant="outlined"
              value={values.otherAmount}
              onChange={value => setFieldValue('otherAmount', value)}
              onBlur={e => handleBlurInput(e, ACTION_TARGETS.GIFT_AMOUNT)}
              error={touched.otherAmount && Boolean(errors.otherAmount)}
              helperText={touched.otherAmount && errors.otherAmount}
            />
          </Box>
        )}
        <Box marginY={4}>
          <TextField
            multiline
            name="message"
            fullWidth
            size="small"
            rowsMax={3}
            rows={values.amount === GIFT_AMOUNT_OTHER ? 2 : 3}
            variant="outlined"
            label="Add a personal message (optional)"
            value={values.message}
            onChange={handleChange}
            onBlur={e => handleBlurInput(e, ACTION_TARGETS.GIFT_MESSAGE)}
            error={touched.message && Boolean(errors.message)}
            helperText={touched.message && errors.message}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <ButtonSubmit color="primary" variant="contained">
          Next
        </ButtonSubmit>
      </DialogActions>
    </>
  )
}

export default StepGiftDetails
